import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const token = localStorage.getItem("token");

const isTokenValid = (token) => {
    if (!token) return false;

    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // seconds
        return decoded.exp && decoded.exp > currentTime;
    } catch {
        return false;
    }
};

const getTokenExpirationTime = (token) => {
    if (!token) return 0;

    try {
        const decoded = jwtDecode(token);
        return decoded.exp * 1000; // convert to milliseconds
    } catch {
        return 0;
    }
};

const valid = isTokenValid(token);

const initialState = {
    token: valid ? token : null,
    isAuthenticated: valid,
    authInitialized: false,
};

let logoutTimer;

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        login(state, action) {
            state.token = action.payload;
            state.isAuthenticated = true;
            localStorage.setItem("token", action.payload);
        },
        logout(state) {
            state.token = null;
            state.isAuthenticated = false;
            localStorage.removeItem("token");
            if (logoutTimer) {
                clearTimeout(logoutTimer);
            }
        },
        setAuthInitialized(state) {
            state.authInitialized = true;
        },
    },
});

export const { login, logout, setAuthInitialized } = authSlice.actions;

// Thunk to schedule automatic logout
export const scheduleLogout = (token) => (dispatch) => {
    const expirationTime = getTokenExpirationTime(token);
    const currentTime = Date.now();

    const timeout = expirationTime - currentTime;

    if (timeout > 0) {
        logoutTimer = setTimeout(() => {
            dispatch(logout());
        }, timeout);
    } else {
        // Token already expired
        dispatch(logout());
    }
};

// Call this on app start to check and schedule logout
export const initializeAuth = () => (dispatch) => {
    const token = localStorage.getItem("token");
    if (isTokenValid(token)) {
        dispatch(login(token));
        dispatch(scheduleLogout(token));
    } else {
        dispatch(logout());
    }
    dispatch(setAuthInitialized());
};

export default authSlice.reducer;
